const { accountType } = require('@transfeeradev/api-enums');

const caixaSchema = {
  account: {
    maxLength: 9
  },
  accountType: {
    allowedTypes: [
      accountType.CONTA_CORRENTE,
      accountType.CONTA_POUPANCA,
      accountType.CONTA_FACIL,
      accountType.ENTIDADES_PUBLICAS
    ]
  }
};

module.exports = caixaSchema;
